// Statuses the backend sets when a project is not running. Matches the "Inactive" tag on field crew cards.
const INACTIVE_STATUSES = ['Inactive', 'Unstarted', 'Ended']

// A project is active unless the backend marks it inactive. The backend checks start/end dates,
// the division season and on_hold when it sets status.
export const isProjectActive = (project) => !INACTIVE_STATUSES.includes(project.status)
